import AbstractTab from "./AbstractTab";
import { addSvg } from "../shared/utils";
import { ADD_LAYER } from "../tools/actions/ActionHelper";

export default class LayersTab extends AbstractTab {
    name = 'layers';
    tooltip = 'Layers (Y)';
    icon = '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg?v=491#stack-line"></use></svg>';

    filtersOpen = false;
    textFilter = '';

    constructor(provider, tabContainer) {
        super(provider);

        this.container = this.p.createDiv()
            .parent(tabContainer)
            .class('planner-aside-wrapper');

        let header = this.p.createDiv()
            .parent(this.container)
            .style('display', 'flex')
            .style('align-items', 'center')
            .style('justify-content', 'space-between')
            .class('mar-b-sm');

        this.p.createElement('H3', 'Layers')
            .parent(header)
            .class('mar-t-0 mar-b-0');

        let headerButtons = this.p.createDiv()
            .parent(header)
            .style('display', 'flex')
            .style('gap', '4px');

        this.filterButton = this.p.createDiv()
            .parent(headerButtons)
            .class('btn-icon')
            .style('cursor', 'pointer')
            .style('width', '32px')
            .style('height', '32px')
            .attribute('data-tooltip', 'Filter')
            .mouseClicked(() => this.toggleFilters());
        addSvg(this.filterButton, 'equalizer-line');
        this.filterButton.elt.querySelector('svg').style.width = '20px';
        this.filterButton.elt.querySelector('svg').style.height = '20px';

        if (!this.viewMode) {
            let addButton = this.p.createDiv()
                .parent(headerButtons)
                .class('btn-icon')
                .style('cursor', 'pointer')
                .style('width', '32px')
                .style('height', '32px')
                .attribute('data-tooltip', 'Add layer')
                .mouseClicked(() => this.addLayer());
            addSvg(addButton, 'add-line');
            addButton.elt.querySelector('svg').style.width = '20px';
            addButton.elt.querySelector('svg').style.height = '20px';
        }

        this.createFilterInputs();
        this.rowContainer = this.p.createDiv().parent(this.container);

        this.container.hide();
    }

    createFilterInputs() {
        this.filterContainer = this.p.createDiv()
            .parent(this.container)
            .style('display', 'flex')
            .style('flex-direction', 'column')
            .style('gap', '6px')
            .style('margin-bottom', '6px')
            .style('display', 'none');

        let inputWrapper = this.p.createDiv()
            .parent(this.filterContainer)
            .style('position', 'relative')
            .style('width', '100%');

        this.textInput = this.p.createInput('')
            .parent(inputWrapper)
            .class('input-text')
            .attribute('placeholder', 'Filter by name...')
            .style('width', '100%')
            .style('box-sizing', 'border-box')
            .style('padding-right', '2rem');
        this.textInput.elt.oninput = () => {
            this.textFilter = this.textInput.value();
            this.applyFilters();
        };
        this.textInput.elt.onfocus = () => this.enableHotKeys = false;
        this.textInput.elt.onblur = () => this.enableHotKeys = true;

        this.clearButton = this.p.createSpan('')
            .parent(inputWrapper)
            .style('position', 'absolute')
            .style('right', '0.5rem')
            .style('top', '50%')
            .style('transform', 'translateY(-50%)')
            .style('cursor', 'pointer')
            .style('line-height', '0');
        this.clearButton.mouseClicked(() => {
            this.textInput.value('');
            this.textFilter = '';
            this.applyFilters();
        });
        addSvg(this.clearButton, 'close-circle-fill');
        this.clearButton.elt.querySelector('svg').style.width = '16px';
        this.clearButton.elt.querySelector('svg').style.height = '16px';
        this.clearButton.elt.querySelector('svg').style.fill = '#bbb';
    }

    toggleFilters() {
        this.filtersOpen = !this.filtersOpen;
        if (this.filtersOpen) {
            this.textInput.value(this.textFilter);
            this.filterContainer.style('display', 'flex');
            this.applyFilters();
        } else {
            this.filterContainer.style('display', 'none');
            this.showAll();
        }
    }

    applyFilters() {
        let text = this.textFilter.toLowerCase();
        Object.values(this.layers.collection).forEach(layer => {
            let match = !text || layer.name.toLowerCase().includes(text);
            match ? layer.row.show() : layer.row.hide();
        });
    }

    showAll() {
        Object.values(this.layers.collection).forEach(layer => layer.row.show());
    }

    addLayer() {
        this.actions.new(ADD_LAYER);
    }

    activate() {
        this.container.show();
        if (this.filtersOpen) {
            this.applyFilters();
        }
    }

    deactivate() {
        this.container.hide();
    }
}
